'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module.recap', {
    url: '/recap',
    views: {
      '@instance.app': {
        templateUrl: '/app/states/module/recap/recap.html',
        controller: function ($scope, $state, Api, module) {
          $scope.module = module;
          Api.track('module.recap', 'view');
          $scope.next = function () {
            Api.track('module.recap', 'pass').then(function () {
              $state.go('^.congratulations', {}, { reload: true });
            });
          };
        }
      }
    }
  });

});
